import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';

import {
  FDBodyText,
  FDTitleText,
  FDStack,
} from '@facet-wealth/design';

const QuestionResponse = ({ questionResponse }) => {
  const renderResponses = () => {
    const responses = questionResponse.attr('response');
    if (!responses || responses.length === 0) {
      return <FDBodyText color={'textDisabled'} value={'No response'} />;
    }
    return responses.map(r => <FDBodyText value={r} />);
  };

  return (
    <FDStack direction={'column'}>
      <FDTitleText value={questionResponse.attr('question')} />
      {renderResponses()}
    </FDStack>
  );
};

QuestionResponse.propTypes = {
  questionResponse: PropTypes.instanceOf(fr.Resource).isRequired,
};

export default QuestionResponse;
